import { usePostMutation } from "../../../hooks/useClientPortalQuery";
import { useClientPortalConfigContext } from "../../../context";
import { AxiosError } from "axios";
import { ValidateTokenRequest } from "types/generated/models";

export interface IUseEncryptToken {
    isPending: boolean;
    encryptToken: (request: ValidateTokenRequest) => Promise<string>;
}

export function useEncryptToken(): IUseEncryptToken {
    const { clientPortalGuid } = useClientPortalConfigContext();

    const { mutateAsync, isPending } = usePostMutation<string, AxiosError, ValidateTokenRequest>({
        url: `/api/v1/${clientPortalGuid}/CustomForm/EncryptToken`,
    });

    return {
        isPending,
        encryptToken: mutateAsync,
    };
}
